import React from 'react'

const Police = () => {
  return (
    <div className='policeContainer'>
        <h1>Marques Driving School Policy Guide</h1>
      
      <div className='PoliceItem'>
          <h2>
          Instructors Responsibilities
          </h2>
          <ul>
            <li>Instructors will behave courteously towards all persons with whom he/she comes in contact when providing services.</li>
            <li>When providing lessons driver instructors shall apply themselves solely to the task and not engage in other activities such as cell phone use, eating or any other activities that are inappropriate or distracting to the learner driver.</li>
            <li>Instructors will comply with the Motor Vehicle Act and its regulation and any other relevant applicable law.</li>
            <li>Instructors will treat all persons equally and with dignity and respect.</li>
            <li>Instructors will conduct themselves professionally and will strive to strengthen and uphold public confidence in the driver training industry.</li>
            <li>Instructors will support road safety and the provision of driver licensing services to British Columbians.</li>
            <li>Instructors will protect the privacy of customers and safeguard any customer records they possess or control in accordance with the Personal Information Protection Act (PIPA).</li>
            <li>Instructors will act with honesty and integrity recognizing they are in a position of trust and authority.</li>
            <li>Instructors are aware of all road rules and regulations and licenses are all current.</li>
          </ul>
      </div>
      <div className='PoliceItem'>
        <h2>Student Expectations</h2>
        <ul>
            <li>Student is mentally, and emotionally fit to undertake the driving lessons, and that their present driver’s license is valid for driving in BC, Canada for the duration of my driving lessons.</li>
            <li>Marques driving school services do not include road tests, however we can make an appointment on your behave for the road test.</li>
            <li>The student declares that they hold harmless Marques Driving School, of and from all claims, demand, losses, causes of action, damage, lawsuits, judgments, including reasonable attorneys’ fees and costs, arising out of or relating to any disputes arising out of any lawfully provided services.</li>
            <li>All lessons will be individual, one on one unless otherwise both parties agree between instructor and student for additional persons being in the vehicle, and their reason for attending the lesson. There will be a maximum of three people.
            </li>
        </ul>
      </div>

      <div className='PoliceItem'>
        <h2>Fees</h2>
        <h3>One lesson</h3>
        <ul>
          <li>Class 5 - Automatic, 1 hour driving lesson – $75</li>
          <li>Class 5 - Automatic, 90 minutes driving lesson – $95</li>
          <li>Class 5 - Automatic 30 minute lesson & car rental for road test – $120</li>
        </ul>
        <h3>Two lesson</h3>
        <ul>
          <li>Class 5 - Automatic, 90 minutes driving lesson – $180</li>
          <li>Class 5 - Automatic, 90 minutes driving lesson – $260</li>
        </ul>
          <h4>Note - ICBC Road test and licensing fees are not included. Prices are subject to change without notice.</h4>
      </div>

      <div className='PoliceItem'>
        <h2>Cancellations</h2>
        <ul>
        <li>To cancel the lesson, please give us a notice within 48 hours, otherwise, a cancellation fee of $30 will be assessed. Same day or last minute cancellation will cost full lesson fee or you will lose the lesson.</li>
            <li>Note: For canceling a road test appointment made by, Marques Driving School, We require 72 hours of notice, as we must notify ICBC. Failure to give Marques Driving School sufficient notice may result in the student being charged a $25 road test cancellation fee to ICBC.</li>
        </ul>
      </div>

      <div className='PoliceItem'>
        <h2>Late</h2>
        <ul>
        <li>If you are late beyond 15 Minutes, the instructor will leave and you will be considered as a ‘NO SHOW’ lesson (no refund or reschedule for that lesson).</li>
        </ul>
      </div>


      <div className='PoliceItem'>
        <h2>Refunds</h2>
        <ul>
        <li>There will be no refund for driving lessons regardless of the outcome of the road test, all lessons purchased are final sale and non-transferable.</li>
            <li>Refunds will be paid for unused lessons provided notice is received by Marques driving School, 48 hours prior to the scheduled lesson(s). The cancellation fee will apply to refunds requested within 48 hours of a scheduled lesson.</li>
        </ul>
      </div>

      <div className='PoliceItem'>
        <h2>General Policies</h2>
        <ul>
            <li>Student must provide a valid BC Learners Driver’s License before any lesson.</li>
            <li>Student must be dressed appropriately and wear proper footwear (no heels).</li>
            <li>All students have to be registered and paid in advance and no later than the first lesson.</li>
            <li>Marques Driving School, may cancel your scheduled appointment for any unforeseen circumstances. For example, instructor being sick, car breaking down, or poor road conditions. Students will be notified as soon as possible. The lesson will be rescheduled.</li>
            <li>Marques Driving School can cancel your lesson with NO refunds if the student is suspected of being under the influence of alcohol, drugs, or using foul, abusive, or aggressive language.</li>
            <li>If a student cause a crash and found at fault by ICBC then deductible amount as per Insurance Policy will have to be paid by the student.</li>
            <li>Student must be dressed appropriately and wear proper footwear (no heels).</li>
            <li>If students are being disrespectful, threatening, or possing any danger the lesson will be cancelled with no refund and will be banned from returning to the school.</li>

        </ul>
      </div>

      <div className='PoliceItem'>
        <h2>COVID-19 health and safety protocols</h2>
        <ul>
            <li>Marques Driving School will ensure all touch surfaces have been disinfected before and after each lesson.</li>
            <li>Mask or face coverings are not required however students are free to use them and also request the instructor to wear one if they so desire.</li>
            <li>Students will be asked general health questions before the lesson and the instructors reserves the right to cancel the lesson if they deem the student to not be fit to do the lesson.</li>
            <li>The instructor reserves the right and discretion to cancel a lesson for any health or suspected health reason or concern.</li>
            <li>If a student has been diagnosed with COVID-19, suspected of having it, or been ordered to self-isolate or quarantine by a public health authority they must inform the school as soon as possible</li>
            <li> In the event of local/community outbreaks Marques driving school reserves the right to cancel/postpone lessons which will be rescheduled for a later date.</li>
        </ul>
      </div>

    </div>
  )
}

export default Police
